export const AUTH_TOKEN_KEY = "AUTH_TOKEN_KEY";
export const AUTH_TOKEN_EXPARATION_KEY = "AUTH_TOKEN_EXPARATION_KEY";
